import React from 'react'
import { Router, Route, Switch } from 'react-router-dom'
import { createBrowserHistory } from 'history'

import KeyComponentTitle from '../components/KeyComponentTitle'
import Header from '../components/Header'
import IntroPage from '../components/IntroPage'
import NotFoundPage from '../components/NotFoundPage'
import QuestionPage from '../components/QuestionPage'
import ResourcesPage from '../components/ResourcesPage'
import ResultsPage from '../components/ResultsPage'
import SectionGuidance from '../components/SectionGuidance'
import StartPage from '../components/StartPage'
import SubSectionMenu from '../components/SubSectionMenu'

export const history = createBrowserHistory()

const AppRouter = () => (
    <Router history={history}>
      <div>
        <Header />
        <Switch>
          <Route path="/" component={IntroPage} exact={true} />
          <Route path="/keyComponent/:secId/:subSecId" component={KeyComponentTitle} />
          <Route path="/start" component={StartPage} />
          <Route path="/menu/:secId" component={SubSectionMenu} />
          <Route path="/results" component={ResultsPage} />
          <Route path="/guidance/:secId/:subSecId" component={SectionGuidance} />
          <Route path="/question/:secId/:subSecId/:qId" component={QuestionPage}/>
          <Route path="/resources" component={ResourcesPage} />
          <Route component={NotFoundPage} />
        </Switch>
      </div>
    </Router>
  )

export default AppRouter


// WEBPACK FOOTER //
// ./src/routers/AppRouter.js